import Hotjar from '@hotjar/browser'
import * as Sentry from '@sentry/react'
import { Integrations as TracingIntegrations } from '@sentry/tracing'
import { isPWA } from './browserUtils'

export function initSentry() {
	const sentryDsn = window?.__RUNTIME_CONFIG__?.REACT_APP_SENTRY_DSN ? window.__RUNTIME_CONFIG__.REACT_APP_SENTRY_DSN : process.env.REACT_APP_SENTRY_DSN
	const sentryEnv = window?.__RUNTIME_CONFIG__?.REACT_APP_SENTRY_ENV ? window.__RUNTIME_CONFIG__.REACT_APP_SENTRY_ENV : process.env.REACT_APP_SENTRY_ENV

	Sentry.init({
		enabled: true,
		release: process.env.REACT_APP_VERSION,
		integrations: [new TracingIntegrations.BrowserTracing()] as any,
		environment: sentryEnv,
		dsn: sentryDsn,
		tracesSampleRate: 0.05
	})
}

export function initHotjar() {
	const siteId = 6437089
	const hotjarVersion = 6

	Hotjar.init(siteId, hotjarVersion)
	Hotjar.event(isPWA() ? 'pwa_mode' : 'browser_mode')
}

export function initElasticApm() {
	// let env = process.env.REACT_APP_ENV || 'production'
	// if (typeof window !== 'undefined') {
	// 	if (window.location.hostname.includes('localhost')) {
	// 		env = 'dev'
	// 	} else if (window.location.hostname.includes('staging')) {
	// 		env = 'staging'
	// 	}
	// }
	// initApm({
	// 	serviceName: 'ewa-web',
	// 	serverUrl: 'https://apm.wagenow.sk:443',
	// 	environment: env,
	// 	breakdownMetrics: true
	// })
}
